
import { useState } from "react";
import { TopNav } from "@/components/navigation/TopNav";
import { WorkspaceSidebar } from "@/components/navigation/WorkspaceSidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { SubscriptionProvider } from "@/contexts/SubscriptionContext";
import { Dashboard as DashboardContent } from "@/components/dashboard/Dashboard";
import { PreviewBanner } from "@/components/ui/preview-banner";

interface DashboardProps {
  children?: React.ReactNode;
}

const Dashboard = ({ children }: DashboardProps) => {
  const [selectedWorkspace, setSelectedWorkspace] = useState<string | undefined>();

  return (
    <SubscriptionProvider>
      <SidebarProvider>
        <div className="min-h-screen w-full">
          <PreviewBanner />
          <div className="fixed top-0 left-0 right-0 z-50">
            <TopNav onWorkspaceSelect={setSelectedWorkspace} />
          </div>
          <div className="flex pt-14">
            <WorkspaceSidebar onWorkspaceChange={setSelectedWorkspace} />
            <SidebarInset className="w-full">
              <div className="relative p-6">
                {children || <DashboardContent selectedWorkspace={selectedWorkspace} />}
              </div>
            </SidebarInset>
          </div>
        </div>
      </SidebarProvider>
    </SubscriptionProvider>
  );
};

export default Dashboard;
